export default "/institutions/vale-transporte.svg";